module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "new-product"
  }, [_c('div', {
    staticClass: "my-4"
  }, [(_vm.step === _vm.currentStep) ? _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.readyToSave.apply(null, arguments)
      },
      "input": function($event) {
        return _vm.productAcivateUpdateFlag('schedule')
      }
    }
  }, [(_vm.isReadOnly) ? _c('div', {
    staticClass: "color-1 my-4 p-4"
  }, [_vm._v("\n                        This product is currently inactive. To make changes, please activate it first.\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "product-schedule__top-options d-flex flex-wrap mb-5"
  }, [_c('div', {
    staticClass: "product-schedule__availability d-flex flex-grow-1"
  }, [_c('div', {
    staticClass: "panel mt-0"
  }, [_c('h5', [_vm._v("Availability - How to manage your resources availability.")]), _vm._v(" "), _c('div', {
    staticClass: "schedule-type-holder d-flex mt-2",
    class: {
      'schedule-type-holder--readonly': _vm.isReadOnly
    }
  }, [_vm._l((_vm.getAvailabilityTypes), function(availabilityType) {
    return _c('button', {
      key: availabilityType.value || availabilityType.label,
      staticClass: "schedule-type-holder__btn btn tertiary",
      class: {
        'schedule-type-holder__btn--selected': _vm.form.availabilityType == availabilityType.value,
        'notAllowed': _vm.isReadOnly
      },
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          return _vm.setAvailabiltyType(availabilityType)
        }
      }
    }, [_vm._v(_vm._s(availabilityType.label))])
  }), _vm._v(" "), (_vm.form.availabilityType == _vm.AvailabilityTypes.FIXED_LIMIT) ? _c('div', {
    staticClass: "ml-2 product-schedule__availability-width"
  }, [_c('label', {
    staticClass: "w-100"
  }, [_vm._v("Max. availability")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.capacity),
      expression: "form.capacity",
      modifiers: {
        "number": true
      }
    }],
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "disabled": _vm.isReadOnly,
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.capacity)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "capacity", _vm._n($event.target.value))
      }, function($event) {
        _vm.$v.form.capacity.$touch, _vm.productAcivateUpdateFlag('scheduleAvailability'), _vm.markAllSchedulesEdited(), _vm.setAvailabiltyOnGroups(false)
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.form.capacity.$invalid) ? _c('div', {
    staticClass: "messages color-6"
  }, [(!_vm.$v.form.capacity.required) ? _c('span', [_vm._v("Please set max availability.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.capacity.customRequired) ? _c('span') : _vm._e()]) : _vm._e()]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "product-schedule__virtual-rooster d-flex"
  }, [_c('div', {
    staticClass: "panel mt-0 d-flex flex-column flex-grow-1"
  }, [_c('h5', [_vm._v("Virtual Roster "), (_vm.disableVirtualRooster) ? _c('span', {
    staticClass: "fs-smaller dark"
  }, [_vm._v("(Only available with \"Availability - Limited by resource\")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-100 d-flex flex-row"
  }, [_c('div', {
    staticClass: "d-flex mr-2 pt-1"
  }, [_c('checkbox', {
    class: {
      'notAllowed opacity-50': _vm.isReadOnly || _vm.disableVirtualRooster
    },
    attrs: {
      "disabled": _vm.isReadOnly || _vm.disableVirtualRooster
    },
    model: {
      value: (_vm.virtualRooster),
      callback: function($$v) {
        _vm.virtualRooster = $$v
      },
      expression: "virtualRooster"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column flex-grow-1"
  }, [_c('div', {
    staticClass: "w-100",
    class: {
      'opacity-50': _vm.disableVirtualRooster
    }
  }, [_vm._v("Do not allocate resources to this activity until the first booking is made. ")]), _vm._v(" "), _c('div', {
    staticClass: "w-100 dark"
  }, [_vm._v("\n                                                This allows you to share resources between different products on a first-come, first-served basis.\n                                            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between mb-2"
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_vm._v("Schedule - Specify dates and hours for your activities.")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    class: ['product-schedule__sort-icon', 'darkest', 'fs-large', 'mr-3', _vm.isOrderDesc ? 'fas fa-sort-amount-down' : 'fas fa-sort-amount-up'],
    on: {
      "click": _vm.toggleOrderDirection
    }
  }), _vm._v(" "), (_vm.form.id) ? _c('button', {
    staticClass: "btn tertiary",
    attrs: {
      "disabled": _vm.isReadOnly || _vm.getIsDownloadingOldGroups,
      "type": "button"
    },
    on: {
      "click": _vm.togglePastGroups
    }
  }, [_vm._v(" " + _vm._s(_vm.hidePastGroups ? 'Show' : 'Hide') + " older schedules")]) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.filteredGroups.length > 0) ? _vm._l((_vm.filteredGroups), function(group, index) {
    return _c('div', {
      key: group.id || index,
      staticClass: "form-group product-schedule d-flex bg-lightest"
    }, [_c('div', {
      staticClass: "row w-100 pt-1 pl-3 pr-0 pb-1"
    }, [_c('div', {
      staticClass: "col-sm-12 my-2 pr-0"
    }, [_c('div', {
      staticClass: "row align-items-center w-100"
    }, [_c('div', {
      staticClass: "col d-flex align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.label),
        expression: "group.label"
      }],
      staticClass: "bg-lightest product-schedule__label-input",
      attrs: {
        "type": "text",
        "placeholder": "Schedule name",
        "disabled": !group.isEditing || group.isEditing == false
      },
      domProps: {
        "value": (group.label)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(group, "label", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.hasGroupPerOrderMissingCategory(group) || _vm.groupMissingResources(group)) ? _c('span', {
      staticClass: "product-schedule__warning-dot"
    }) : _vm._e(), _vm._v(" "), (group.isEdited && group.isEdited == true) ? _c('span', {
      staticClass: "fs-small dark ml-2"
    }, [_vm._v("edited")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col d-flex align-items-center justify-content-center"
    }, [_c('span', {
      staticClass: "product-schedule__dates-label"
    }, [_vm._v("Dates")]), _vm._v(" "), _c('input', {
      staticClass: "bg-lightest ml-2 text-center product-schedule__dates-input",
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": _vm.formatDateRange(group.dateFrom, group.dateTo)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col d-flex align-items-center justify-content-end pr-0"
    }, [(!group.readOnly && group.id) ? _c('span', {
      staticClass: "bold darker fs-small mx-3 pointer",
      on: {
        "click": function($event) {
          return _vm.duplicateRow(group)
        }
      }
    }, [_vm._v("Duplicate")]) : _vm._e(), _vm._v(" "), (!group.readOnly) ? _c('span', {
      staticClass: "bold darker fs-small mx-3 pointer",
      on: {
        "click": function($event) {
          return _vm.deleteItem(index, 'groups', group)
        }
      }
    }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), (!_vm.isCreatingProduct && !group.readOnly) ? _c('div', [(!group.isEditing || group.isEditing == false) ? _c('span', {
      staticClass: "bold darker fs-small mx-3 pointer",
      on: {
        "click": function($event) {
          return _vm.editGroupToggle(group, false)
        }
      }
    }, [_vm._v(_vm._s((group.isEditing && group.isEditing) ? 'Editing' : 'Edit'))]) : _vm._e(), _vm._v(" "), (group.isEditing && group.isEditing == true && group.id) ? _c('button', {
      staticClass: "btn tertiary mx-3",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.cancelEditGroup(group, index)
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (group.isEditing && group.isEditing == true) ? _c('button', {
      staticClass: "btn primary mx-3",
      attrs: {
        "type": "button",
        "disabled": !_vm.groupHasChanges(group) || !_vm.hasWeekDays || _vm.hasRepeatedCustomsPrices(group) || _vm.hasPriceGroupDecompositionError(group) || _vm.hasCustomPricesWithoutCategory(group) || _vm.hasGroupPerOrderMissingCategory(group) || _vm.rulePaxNotReady || _vm.groupMissingResources(group)
      },
      on: {
        "click": function($event) {
          return _vm.editGroupToggle(group, true)
        }
      }
    }, [_vm._v("Confirm")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "ico mx-0 fs-normal pointer",
      class: {
        'ico-arrow-top': group.expanded,
        'ico-arrow-bottom': !group.expanded
      },
      on: {
        "click": function($event) {
          return _vm.toggleGroupExpanded(group)
        }
      }
    })])])]), _vm._v(" "), (group.expanded) ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "col-sm-12 panel shaded mt-0 mb-3"
    }, [_c('product-schedule-group-time-dates', {
      attrs: {
        "group": group,
        "form": _vm.form
      },
      on: {
        "update:group": function($event) {
          group = $event
        },
        "update": function($event) {
          return _vm.productAcivateUpdateFlag('schedule')
        },
        "hasWeekDays": function($event) {
          return _vm.setWeekDays($event)
        }
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (group.expanded) ? _c('div', {
      staticClass: "col-md-6 pb-3"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "panel shadded mt-0"
    }, [_c('div', {
      staticClass: "d-flex pb-3 mb-3 border-bottom-light justify-content-between align-items-center pointer",
      on: {
        "click": function($event) {
          return _vm.toggleExpand(group)
        }
      }
    }, [_c('span', {
      staticClass: "font-weight-600"
    }, [_vm._v("PRICES "), (_vm.hasGroupPerOrderMissingCategory(group)) ? _c('span', {
      staticClass: "product-schedule__warning-dot"
    }) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "ico mx-0 fs-normal",
      class: {
        'ico-arrow-top': group.pricesExpanded,
        'ico-arrow-bottom': !group.pricesExpanded
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product-schedule__panel-holder",
      class: {
        'product-schedule__panel-holder--closed': !group.pricesExpanded
      }
    }, [_c('pricing-manager', {
      staticClass: "panel mt-0",
      staticStyle: {
        "padding": "1.5rem 0",
        "background": "#F3F5F6"
      },
      attrs: {
        "disabled": !group.isEditing || group.isEditing == false,
        "group": group,
        "backuped-pricing-type": group && group.backupGroup && group.backupGroup.selectedPrincingType ? group.backupGroup.selectedPrincingType : null,
        "priceTypeConfig": {
          isDisable: _vm.hasRestrictions(group.id),
          type: 'product'
        }
      },
      on: {
        "isReadyToSubmitPricingManager": function($event) {
          return _vm.setIsReadyToSubmitPricingManager($event)
        }
      },
      model: {
        value: (group.productGenderPrices),
        callback: function($$v) {
          _vm.$set(group, "productGenderPrices", $$v)
        },
        expression: "group.productGenderPrices"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('ResourcesManager', {
      staticClass: "panel shaded",
      attrs: {
        "disabled": !group.isEditing || group.isEditing == false,
        "readOnly": group.readOnly,
        "form": _vm.form,
        "group": group
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [(_vm.hasDynamicPricingRevenuePlugin) ? _c('RulesManager', {
      staticClass: "panel shaded",
      attrs: {
        "disabled": !group.isEditing || group.isEditing == false,
        "readOnly": group.readOnly,
        "group": group,
        "type": "productGroupPriceGroups"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('MinMaxManager', {
      staticClass: "panel shaded",
      attrs: {
        "disabled": !group.isEditing || group.isEditing == false,
        "readOnly": group.readOnly,
        "form": _vm.form,
        "group": group
      },
      on: {
        "isReadyToSubmit": function($event) {
          return _vm.validateRulePax($event)
        }
      }
    })], 1)])]) : _vm._e()])])
  }) : _vm._e(), _vm._v(" "), (_vm.filteredGroups.length == 0) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('span', {
    staticClass: "dark fs-large w-100 text-center"
  }, [_vm._v("Looks like you have no active schedules, feel free to "), _c('b', {
    class: ['pointer', {
      notAllowed: _vm.isReadOnly
    }],
    on: {
      "click": _vm.handleAddGroup
    }
  }, [_vm._v("add a new one")]), _vm._v("!")]), _vm._v(" "), (_vm.pastGroups.length > 0) ? _c('span', {
    staticClass: "dark fs-small w-100 text-center"
  }, [_vm._v("You have " + _vm._s(_vm.pastGroups.length) + " older schedule" + _vm._s(_vm.pastGroups.length > 1 ? 's' : '') + " that are hidden, "), _c('b', {
    staticClass: "pointer",
    on: {
      "click": _vm.togglePastGroups
    }
  }, [_vm._v("show all")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn tertiary",
    class: {
      notAllowed: _vm.isReadOnly
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.handleAddGroup
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new schedule\n                                    ")])], 2)])])])])]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-332e1fc4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-332e1fc4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductSchedule.vue
// module id = 1640
// module chunks = 0